<template>
  <transition name="modal" v-if="editRebateItem">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="cancel">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Edit Rebate Item</h3>
            <a
              href=""
              @click.prevent="">

            </a>
          </div>
          <div class="modal-body form-horizontal">
            <section>
              <h4>Common Fields</h4>
              <br>
              <div class="form-group">
                <label for="fieldName" class="control-label col-sm-3">Name</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="fieldName"
                    class="form-control admin-form-control"
                    type="text" name="name"
                    v-model="currentRebateItem.name"
                    placeholder="Name">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="fieldPoints" class="control-label col-sm-3">Points</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="fieldPoints"
                    class="form-control admin-form-control"
                    type="number" name="points"
                    v-model="currentRebateItem.points"
                    placeholder="Points">
                </div>
              </div>
              <div class="clearfix"></div>
              <form-image-uploader
                v-model="currentRebateItem.image"
                :albumName="'rebateItems'"
                :inputLabel="'Image'"
                ></form-image-uploader>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="disable" class="control-label col-sm-3">Disable</label>
                <div class="col-sm-9 input-group checkbox-center">
                  <input
                    id="disable"
                    v-model="currentRebateItem.disabled"
                    type="checkbox"
                    name="">
                </div>
              </div>
            </section>
            <section v-if="program.rebateItemFields.length > 0">
              <h4>Program Unique Fields</h4>
              <br>
              <div
                class="programUniqueFields"
                v-for="(field, index) in program.rebateItemFields" :key="index"
                >
                <div
                  v-if="field.field === 'category'"
                  class="form-group">
                  <label for="fieldType" class="control-label col-sm-3">{{ field.displayName }}</label>
                  <div class="col-sm-9 input-group">
                    <select id="fieldCategory" v-model="currentRebateItem[field.field]" class="form-control admin-form-control">
                      <option value="" disabled selected>Item Category</option>
                      <option v-for="(category, index) in program.categories" :key="index" :value="category.category">{{ category.category }}</option>
                    </select>
                  </div>
                </div>
                <div
                  v-else
                  class="form-group">
                  <label :for="`field-${field.field}`" class="control-label col-sm-3">{{ field.displayName }}</label>
                  <div class="col-sm-9 input-group">
                    <input
                      :id="`field-${field.field}`"
                      class="form-control admin-form-control"
                      type="text" name="points"
                      v-model="currentRebateItem[field.field]"
                      :placeholder="field.displayName">
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="cancel">Cancel</button>
            <button class="btn admin-btn-primary" @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import FormImageUploader from '../../FormImageUploader'

export default {
  name: 'RebateItemModal',
  props: ['editRebateItem', 'currentRebateItemId', 'program', 'isNew'],
  components: {
    'form-image-uploader': FormImageUploader
  },
  watch: {
    editRebateItem: function (val) {
      if (val) {
        this.rebateItemOriginalData = JSON.parse(JSON.stringify(this.currentRebateItem))
      } else {
        this.rebateItemOriginalData = {}
      }
    }
  },
  data () {
    return {
      rebateItemOriginalData: {}
    }
  },
  computed: {
    currentRebateItem: {
      get () {
        return this.isNew
          ? this.program.rebateItems[this.program.rebateItems.length - 1]
          : this.program.rebateItems.find(item => item._id === this.currentRebateItemId)
      },
      set (value) {
        const itemIndex = this.isNew
          ? this.program.rebateItems.length - 1
          : this.program.rebateItems.findIndex(item => item._id === this.currentRebateItemId)
        this.program.rebateItems[itemIndex] = value
      }
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      setProgram: 'SET_PROGRAM',
      updateProgram: 'UPDATE_PROGRAM'
    }),
    ...mapActions('loyaltyProgram', [ 'saveProgram' ]),
    handleEnabling () {

    },
    save () {
      this.setProgram(this.program)
      this.saveProgram()
        .then(response => {
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancel () {
      if (this.isNew) {
        const copyWithoutLast = this.program.rebateItems.slice(0, -1)
        this.updateProgram({ prop: 'rebateItems', value: copyWithoutLast })
      } else {
        this.currentRebateItem = this.rebateItemOriginalData
      }
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.checkbox-center {
  display: flex;
  align-items: center;
  height: 27px;
}

.modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .6s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
